import { Component, EventEmitter, Inject, Input, Optional, Output } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions, GridRow } from '@app/core/components/grid/grid.types';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateDialogContext, TT_STATE_DIALOG } from '@app/modal/state-modal/state-modal.component';

@GridModalComponent('matcertcreate')
@Component({
    selector: 'tt-matcert-create',
    templateUrl: './matcert-create.component.html',
    styleUrls: ['./matcert-create.component.css'],
})
export class MatcertCreateComponent {
    @Input()
    public params?: MatcertCreateParams;

    public get?: MatcertCreateGet;

    public grid?: GridOptions;

    @Output()
    public submit = new EventEmitter<CreateMaterialCertificateResponse>();

    constructor(
        private datatask: DataTaskService,
        private modal: ModalService,
        @Optional() @Inject(TT_STATE_DIALOG) stateContext: StateDialogContext,
    ) {
        this.initFromDialog(stateContext);
    }

    private async loadGet() {
        if (!!this.params) {
            this.get = await this.getMatcertCreate(this.params);
        }
    }

    private readGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_matcert_create_grid')
                .setLoadDataFunction({ method: 3933, parameters: () => this.params })
                .setCustomToolbarButtons([{ name: 'matcertcreate_create', text: 'matcertcreate_create', translate: true, func: this.createMaterialCertificateFromSelectedRows.bind(this), icon: 'fas fa-plus', cssClass: 'im-grid-btn-xs-l tt-button tt-button--success', disable_if_no_selected: true }]);
        } else {
            this.grid.gridfunc?.read();
        }
    }

    private async createMaterialCertificateFromSelectedRows() {
        if (!this.get) return;
        const rows = this.grid?.gridfunc?.getIsSelectedRows() ?? [];

        const { errorcode, errormessage, matcert_keyno } = await this.createMaterialCertificates({ order_internal_no: this.get.order_internal_no, orderlines: rows });

        if ('' + errorcode !== '0') {
            this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
        } else {
            this.submit.emit({ errorcode, errormessage, matcert_keyno });
        }
    }

    private async getMatcertCreate(params: MatcertCreateParams): Promise<MatcertCreateGet> {
        return (await this.datatask.Post(3932, params))[0];
    }

    private async createMaterialCertificates(params: CreateMaterialCertificateParams): Promise<CreateMaterialCertificateResponse> {
        return (await this.datatask.Post(3934, params))[0];
    }

    private async init() {
        this.readGrid();
        await this.loadGet();
        //
    }

    private async initFromDialog(state?: StateDialogContext) {
        if (!!state) {
            this.params = state.params as unknown as MatcertCreateParams;
            state.setSize({ height: '80vh', width: '80vw' });
            await this.init();
            state.setHeading(this.get?.webpage_heading ?? '');
            this.submit.subscribe({ next: (value: ErrorMessageResponse) => state.close(value) });
        }
    }
}

interface MatcertCreateParams {
    order_internal_no: string;
}

interface MatcertCreateGet {
    order_internal_no: string;
    webpage_heading: string;
}
interface CreateMaterialCertificateParams {
    orderlines: GridRow[];
    order_internal_no: string;
}
export interface CreateMaterialCertificateResponse extends ErrorMessageResponse {
    matcert_keyno: string;
}
